import React, { useEffect, useRef } from 'react'

interface AnimatedWrapperProps {
    children: React.ReactNode
    animationName: string
    duration: number
    delay?: number
}

const AnimatedWrapper: React.FC<AnimatedWrapperProps> = ({
    children,
    animationName,
    duration,
    delay = 0
}) => {
    const ref = useRef<HTMLDivElement>(null)

    useEffect(() => {
        const element = ref.current
        if (!element) return

        // Add animation class on mount
        element.classList.add(animationName)

        // Remove animation class after duration
        const timeout = setTimeout(() => {
            element.classList.remove(animationName)
        }, duration + delay)

        return () => clearTimeout(timeout)
    }, [animationName, duration, delay])

    return (
        <div
            ref={ref}
            style={{
                animationDuration: `${duration}ms`,
                animationDelay: `${delay}ms`
            }}
        >
            {children}
        </div>
    )
}

export default AnimatedWrapper
